// https://tiptap.dev/docs/editor/getting-started/install/alpine

import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'

export default () => {
  let editor

  return {
    currentContent: null,
    updatedAt: Date.now(),
    init(){
      const _this = this
      const textArea = this.$el.querySelector('textarea')
      this.currentContent = textArea.value
      const startingContent = this.currentContent
      this.$watch('currentContent', (newValue) => textArea.value = newValue)

      editor = new Editor({
        element: this.$refs.editor,
        extensions: [
          StarterKit,
          Link.configure({
            openOnClick: false,
            autolink: false,
          })
        ],
        content: startingContent,
        onCreate({ editor }) {
          _this.updatedAt = Date.now()
        },
        onUpdate({ editor }){
          _this.updatedAt = Date.now()
        },
        onSelectionUpdate({ editor }){
          _this.updatedAt = Date.now()
        }
      })

      this.$watch('updatedAt', () => {
        _this.currentContent = editor.getHTML()
      })
    },
    isLoaded(){
      return editor
    },
    isActive(type, opts={}){
      return editor.isActive(type, opts)
    },
    toggleHeading(opts){
      editor.chain().focus().toggleHeading(opts).run()
    },
    toggleBold() {
      editor.chain().focus().toggleBold().run()
    },
    toggleItalic() {
      editor.chain().focus().toggleItalic().run()
    },
    toggleBulletList() {
      editor.chain().focus().toggleBulletList().run()
    },
    toggleOrderedList() {
      editor.chain().focus().toggleOrderedList().run()
    },
    toggleBlockquote() {
      editor.chain().focus().toggleBlockquote().run()
    },
    setHorizontalRule() {
      editor.chain().focus().setHorizontalRule().run()
    },
    undo(){
      editor.chain().focus().undo().run()
    },
    redo(){
      editor.chain().focus().redo().run()
    },
    setLink(){
      // https://tiptap.dev/docs/editor/extensions/marks/link
      const previousUrl = editor.getAttributes('link').href
      const url = window.prompt('URL', previousUrl)

      // cancelled
      if (url === null) return

      // empty
      if (url === '') {
        editor.chain().focus().extendMarkRange('link').unsetLink().run()
        return
      }

      // update link
      editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
    }
  }
}